/* FABEL — mobile-menu.js : slide-out navigation with nested panels. */
(function () {
  'use strict';
  const Drawer = window.FABEL && window.FABEL.FabelDrawer;
  if (!Drawer) return;

  class MobileMenu extends Drawer {
    connectedCallback() {
      super.connectedCallback();
      this.panels = Array.from(this.querySelectorAll('[data-submenu]'));

      this.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-submenu-open]');
        if (opener) {
          event.preventDefault();
          this.openPanel(opener.getAttribute('data-submenu-open'), opener);
          return;
        }
        const back = event.target.closest('[data-submenu-back]');
        if (back) {
          event.preventDefault();
          this.closePanel(back.closest('[data-submenu]'));
        }
      });
    }

    openPanel(id, opener) {
      const panel = this.querySelector(`[data-submenu="${id}"]`);
      if (!panel) return;
      panel.setAttribute('data-open', 'true');
      panel.dataset.opener = opener ? opener.id || '' : '';
      const first = panel.querySelector(window.FABEL.FOCUSABLE);
      if (first) window.requestAnimationFrame(() => first.focus({ preventScroll: true }));
    }

    closePanel(panel) {
      if (!panel) return;
      panel.removeAttribute('data-open');
      const opener = panel.dataset.opener && document.getElementById(panel.dataset.opener);
      if (opener) opener.focus({ preventScroll: true });
    }

    close() {
      this.panels.forEach((panel) => panel.removeAttribute('data-open'));
      super.close();
    }
  }
  if (!customElements.get('mobile-menu')) customElements.define('mobile-menu', MobileMenu);
})();
